export default __webpack_public_path__ + "static/media/img-0339-ukraine-full-face.cb9b3d34.png";